import React, {useCallback, useContext} from 'react';
import {AutoField} from '../fields';
import {Link} from 'react-router-dom';
import EndSection from 'components/forms/EndSection';
import {Button, FormHelperText, Typography} from '@material-ui/core';
import fields from 'components/forms/supporting/fields';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';
import {useFieldData} from 'components/forms/hooks';
import {useClearForm} from 'components/forms/hooks';
import {FormState} from 'components/forms/context';
import {SiteUrls} from '../../../constants';

const DocInfo = ({children}) => {
    const fieldDict = fields;
    const sectionFields = [
        'supporting_document_type',
        'twic_card_receipt_type',
        'twic_card_receipt_date',
        'twic_card_date_expired',
        'drug_test_type',
        'drug_test_date_issued',
        'mmc_image_document_number',
        'mariner_fees_receipt',
        'mariner_fees_receipt_used_previous',
        'oath_date',
        'oath_used_previous',
        'proof_of_identification_type',
        'passport_date_issued',
        'passport_date_expired',
        'proof_of_ownership_type',
        'proof_of_ownership_date_issued',
        'qual_letter_service',
        'qual_letter_ood_or_eow',
        'qual_letter_army_deck_engine',
        'qual_letter_date_issued',
        'qual_letter_vessel',
        'extra_maritime_document_name',
        'extra_maritime_document_date_issued',
        'extra_maritime_document_date_expired',
        'extra_maritime_document_additional_information',
    ];
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues({}, sectionFields, fieldDict);
    const [type, setType] = useFieldData('supporting_document_type');
    const updateDocType = e => {
        setType(e.currentTarget.value);
    };
    const [id, setID] = useFieldData('proof_of_identification_type');
    const updateIDType = e => {
        setID(e.currentTarget.value);
    };
    const [army, setArmy] = useFieldData('qual_letter_service');
    const updateArmy = e => {
        setArmy(e.currentTarget.value);
    };
    const [mmc, setMMC] = useFieldData('mmc_all_pages');
    const {node} = useContext(FormState);
    const clearForm = useClearForm(node);
    const onAbortClick = useCallback(() => {
        clearForm();
    }, [clearForm]);
    const showWarning = mmc === false || mmc === 'false';

    const updateMMC = event => {
        setMMC(event.target.value === 'true');
    };

    return (
        <EndSection
            schema={schema}
            initialValues={initialValues}
            endpointOverride='supporting_document'
            redirectUrl={SiteUrls.SUPPORTING_DOCS}
        >
            <AutoField
                field={fields['supporting_document_type']}
                name='supporting_document_type'
                onChange={updateDocType}
            />
            <br></br>

            {type === 'TWIC Receipt' && [
                <AutoField
                    field={fields['twic_card_receipt_type']}
                    name='twic_card_receipt_type'
                />,
                <br />,
                <AutoField
                    field={fields['twic_card_receipt_date']}
                    name='twic_card_receipt_date'
                />,
            ]}
            {type === 'TWIC Card' && (
                <AutoField
                    field={fields['twic_card_date_expired']}
                    name='twic_card_date_expired'
                />
            )}

            {type === 'DOT/ USCG Periodic Drug Test Document' && [
                <AutoField
                    field={fields['drug_test_type']}
                    name='drug_test_type'
                />,
                <br />,
                <AutoField
                    field={fields['drug_test_date_issued']}
                    name='drug_test_date_issued'
                />,
            ]}

            {type === 'Picture of my Merchant Mariner Credential' && [
                <AutoField
                    field={fields['mmc_all_pages']}
                    name='mmc_all_pages'
                    onChange={updateMMC}
                />,
                <br />,
                <AutoField
                    field={fields['mmc_image_document_number']}
                    name='mmc_image_document_number'
                />,
            ]}

            {type === 'USCG Pay.gov Fees Receipt' && [
                <AutoField
                    field={fields['mariner_fees_receipt']}
                    name='mariner_fees_receipt'
                />,
                <br />,
                <AutoField
                    field={fields['mariner_fees_receipt_used_previous']}
                    name='mariner_fees_receipt_used_previous'
                />,
            ]}

            {type === 'Merchant Mariner Oath' && [
                <AutoField field={fields['oath_date']} name='oath_date' />,
                <br />,
                <AutoField
                    field={fields['oath_used_previous']}
                    name='oath_used_previous'
                />,
            ]}

            {type === 'Proof of Identification' && (
                <div>
                    <AutoField
                        field={fields['proof_of_identification_type']}
                        name='proof_of_identification_type'
                        onChange={updateIDType}
                    />
                    {id === 'Passport' && (
                        <div>
                            <AutoField
                                field={fields['passport_date_issued']}
                                name='passport_date_issued'
                            />
                            <AutoField
                                field={fields['passport_date_expired']}
                                name='passport_date_expired'
                            />
                        </div>
                    )}
                </div>
            )}
            {type === 'Proof of Ownership for CG-719S' && [
                <AutoField
                    field={fields['proof_of_ownership_type']}
                    name='proof_of_ownership_type'
                />,
                <AutoField
                    field={fields['proof_of_ownership_date_issued']}
                    name='proof_of_ownership_date_issued'
                />,
            ]}
            {type === 'Active Duty Qualification Letter' && (
                <div>
                    <AutoField
                        field={fields['qual_letter_service']}
                        name='qual_letter_service'
                        onChange={updateArmy}
                    />
                    {(army === 'USCG' ||
                        army === 'NOAA' ||
                        army === 'NAVY' ||
                        army === 'MARINES' ||
                        army === 'USPHS' ||
                        army === 'AIR FORCE' ||
                        army === 'SPACE FORCE') && [
                        <AutoField
                            field={fields['qual_letter_ood_or_eow']}
                            name='qual_letter_ood_or_eow'
                        />,
                    ]}
                    {army === 'ARMY' && [
                        <AutoField
                            field={fields['qual_letter_army_deck_engine']}
                            name='qual_letter_army_deck_engine'
                        />,
                    ]}
                    <AutoField
                        field={fields['qual_letter_date_issued']}
                        name='qual_letter_date_issued'
                    />

                    <AutoField
                        field={fields['qual_letter_vessel']}
                        name='qual_letter_vessel'
                    />
                </div>
            )}
            {type === 'Other Mariner Document' && [
                <AutoField
                    field={fields['extra_maritime_document_name']}
                    name='extra_maritime_document_name'
                />,
                <br />,
                <Typography>
                    Enter dates and additional info about this mariner document
                    if applicable. Otherwise leave these blank.
                </Typography>,
                <br />,
                <AutoField
                    field={fields['extra_maritime_document_date_issued']}
                    name='extra_maritime_document_date_issued'
                />,
                <br />,
                <AutoField
                    field={fields['extra_maritime_document_date_expired']}
                    name='extra_maritime_document_date_expired'
                />,
                <br />,
                <AutoField
                    field={
                        fields['extra_maritime_document_additional_information']
                    }
                    name='extra_maritime_document_additional_information'
                />,
            ]}
            {showWarning && (
                <div>
                    <FormHelperText error>
                        The NMC needs every page of your MMC which has
                        information on it for renewing or upgrading. Click on
                        the button below and re-upload your MMC with an image of
                        every page.
                    </FormHelperText>
                    <p></p>
                    <Button
                        component={Link}
                        to='/seaservice'
                        variant='contained'
                        color='secondary'
                        onClick={onAbortClick}
                    >
                        Discard and Exit
                    </Button>
                </div>
            )}
            {children}
        </EndSection>
    );
};

export default DocInfo;
